var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 122"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 20",
    cx: 25,
    cy: 25,
    r: 24.25,
    fill: "white",
    stroke: "#792122",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 2 Copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 2",
    d: "M38.1653 25.3618H13.1653",
    stroke: "#792122",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 2",
    d: "M18.3618 19L12 25.3618L18.3618 31.7237",
    stroke: "#792122",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.9280407a3df9969e346142b49c551e4b.svg";
export { ForwardRef as ReactComponent };